function base64DecodeUnicode(str) {
  try {
    return decodeURIComponent(
      [...atob(str)].map((c) => {
        const code = c.charCodeAt(0).toString(16).toUpperCase();
        const ensureLengthCode = code.length < 2 ? `0${code}` : code;
        return `%${ensureLengthCode}`;
      }).join("")
    );
  } catch {
    return atob(str);
  }
}
function base64UrlDecode(base64Url) {
  return base64DecodeUnicode(base64Url.replace(/-/g, "+").replace(/_/g, "/"));
}
function jwtDecode(jwtToken) {
  return JSON.parse(base64UrlDecode(jwtToken.split(".")[1]));
}
function isTokenExpired(jwtToken, { secondsBefore = 0, issuedAt = 0 } = {}) {
  if (!jwtToken)
    return false;
  const { exp, iat } = jwtDecode(jwtToken);
  if (exp === void 0)
    return false;
  if (iat === void 0 || !issuedAt)
    return Math.trunc(Date.now() / 1e3) + secondsBefore >= exp;
  const elapsedSeconds = Math.trunc(Date.now() / 1e3) - Math.trunc(issuedAt / 1e3);
  return elapsedSeconds + secondsBefore >= exp - iat;
}

export { base64DecodeUnicode, base64UrlDecode, isTokenExpired, jwtDecode };
//# sourceMappingURL=jwt.js.map
